import { useMutation } from '@tanstack/react-query';
import { updateUserInsightsTimeframe } from 'shared/services/backend-api';
import { InsightsTimeframes } from 'shared/types/insights';

export const useUpdateInsightsTimeframeMutation = () =>
  useMutation({
    mutationFn: async (timeframe: InsightsTimeframes) =>
      updateUserInsightsTimeframe(timeframe),
  });
